// extracted by mini-css-extract-plugin
export default {"content":"zdLCRY","col":"IwlFH0","left":"BcJx8V","price":"cfn1lx","sku":"uGRc_6","right":"nAKAT9","actions":"C5ZOVB","options":"_8Vk7e","view-more":"mwV_76","viewMore":"mwV_76"};